import { Link } from "react-router-dom";
import { useAuth } from "../stores/auth";

export function PinSetupBanner() {
  const user = useAuth((s) => s.user);
  const userSecurity = useAuth((s) => s.userSecurity);
  const sessionLocked = useAuth((s) => s.sessionLocked);

  if (
    !user ||
    sessionLocked ||
    !userSecurity?.pinEnabled ||
    !userSecurity.pinSetupNotify ||
    userSecurity.pinSet
  ) {
    return null;
  }

  return (
    <div className="mx-4 mb-3 rounded-xl border border-brand-pink/30 bg-brand-pink/10 px-3 py-2.5 text-xs">
      <span className="text-white/80">Set a PIN for quick re-login after timeout. </span>
      <Link to="/account/settings" className="font-semibold text-brand-pink">
        Set up PIN
      </Link>
    </div>
  );
}
